import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ActionButtons } from 'src/app/core/Services/shared.service';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss']
})

export class DialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public config: Dialog) {}
}

// Dialoge box notification with optional action handler
export interface Dialog {
    title: string;
    body: string;
    color?: 'primary' | 'accent' | 'warn';
    handlers?: ActionButtons[]
}